import { render, staticRenderFns } from "./PropertiesPanel.vue?vue&type=template&id=4c1e15ee"
import script from "./PropertiesPanel.vue?vue&type=script&lang=js"
export * from "./PropertiesPanel.vue?vue&type=script&lang=js"
import style0 from "./PropertiesPanel.vue?vue&type=style&index=0&id=4c1e15ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports